import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    useCartContext,
    useModalsContext,
    useStoreConfigContext,
    useMessagesContext,
} from '/src/providers';
import { MaxSaleQtyMessage, SmallQuantityButtons } from '/src/components';
import { STOCK_STATUSES } from '/src/consts';
import * as styles from './styles.scss';

const IconBasket = () => (
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5 6.5834V7.08905C16.5 7.29566 16.436 7.47508 16.308 7.62732C16.18 7.77956 16.0212 7.85568 15.8316 7.85568H15.6182L14.8929 13.6788C14.8455 14.0594 14.6938 14.3747 14.4378 14.6248C14.1818 14.8749 13.8926 15 13.5702 15H3.42978C3.09793 15 2.80637 14.8722 2.55511 14.6167C2.30385 14.3611 2.15926 14.0485 2.12133 13.6788L1.396 7.85568H1.16844C0.988296 7.85568 0.831852 7.77956 0.699111 7.62732C0.56637 7.47508 0.5 7.29566 0.5 7.08905V6.5834C0.5 6.36592 0.56637 6.18378 0.699111 6.03698C0.831852 5.89017 0.988296 5.81677 1.16844 5.81677H3.03156L6.004 1.13545C6.14622 0.907092 6.33822 0.771165 6.58 0.727669C6.82178 0.684172 7.04222 0.746698 7.24133 0.915248C7.44044 1.0838 7.55896 1.30672 7.59689 1.58401C7.63481 1.8613 7.58267 2.11412 7.44044 2.34248L5.236 5.81677H11.764L9.55956 2.34248C9.41733 2.11412 9.36519 1.8613 9.40311 1.58401C9.44104 1.30672 9.55956 1.0838 9.75867 0.915248C9.95778 0.746698 10.1782 0.684172 10.42 0.727669C10.6618 0.771165 10.8538 0.907092 10.996 1.13545L13.9684 5.81677H15.8316C16.0212 5.81677 16.18 5.89017 16.308 6.03698C16.436 6.18378 16.5 6.36592 16.5 6.5834ZM9.16133 12.1945V8.62231C9.16133 8.4157 9.09733 8.23627 8.96933 8.08404C8.84133 7.9318 8.68726 7.85568 8.50711 7.85568C8.32696 7.85568 8.17052 7.9318 8.03778 8.08404C7.90504 8.23627 7.83867 8.4157 7.83867 8.62231V12.1945C7.83867 12.4011 7.90504 12.5778 8.03778 12.7246C8.17052 12.8714 8.32696 12.9448 8.50711 12.9448C8.68726 12.9448 8.84133 12.8714 8.96933 12.7246C9.09733 12.5778 9.16133 12.4011 9.16133 12.1945ZM12.276 12.1945V8.62231C12.276 8.40482 12.212 8.22268 12.084 8.07588C11.956 7.92908 11.7996 7.85568 11.6147 7.85568C11.4298 7.85568 11.271 7.92908 11.1382 8.07588C11.0055 8.22268 10.9391 8.40482 10.9391 8.62231V12.1945C10.9391 12.4011 11.0055 12.5778 11.1382 12.7246C11.271 12.8714 11.4274 12.9448 11.6076 12.9448C11.7877 12.9448 11.9441 12.8714 12.0769 12.7246C12.2096 12.5778 12.276 12.4011 12.276 12.1945ZM6.06089 12.1945V8.62231C6.06089 8.40482 5.99689 8.22268 5.86889 8.07588C5.74089 7.92908 5.58444 7.85568 5.39956 7.85568C5.21467 7.85568 5.05585 7.92908 4.92311 8.07588C4.79037 8.22268 4.724 8.40482 4.724 8.62231V12.1945C4.724 12.4011 4.79037 12.5778 4.92311 12.7246C5.05585 12.8714 5.2123 12.9448 5.39244 12.9448C5.57259 12.9448 5.72904 12.8714 5.86178 12.7246C5.99452 12.5778 6.06089 12.4011 6.06089 12.1945Z" fill="white"/>
    </svg>
);

let handlerHide = null;

const AddedProductsMessage = ({ addedProducts = [] }) => {
    const navigate = useNavigate();
    const { translate, formatPrice } = useStoreConfigContext();
    const { hideMessage } = useMessagesContext();
    const { showModal, MODALS_TYPES } = useModalsContext();
    const {
        cart: {
            id: cartId,
            itemsV2: { items = [] } = {},
        },
        isLoadingCart,
        updateCartItems,
    } = useCartContext();
    const [productQty, setProductQty] = useState({});
    const cartItems = items.filter(({ product: { sku }}) => addedProducts.includes(sku));

    const getPackageSize = (additionalAttributeData, displayWeight) => {
        const { value } = additionalAttributeData?.find(({ option_id }) => option_id === displayWeight) || {};

        return value;
    };

    useEffect(() => {
        let handler = null;

        if (!!Object.keys(productQty).length) {
            handler = setTimeout(() => {
                const cartItems = [];

                Object.keys(productQty).forEach(key => {
                    cartItems.push({
                        cart_item_id: key,
                        quantity: productQty[key],
                    })
                });

                updateCartItems({
                    input: {
                        cart_id: cartId,
                        cart_items: cartItems
                    }
                }).catch(errors => {
                    showModal(MODALS_TYPES.ERROR, { errors })
                });
            }, 1000);
        }

        return () => { clearTimeout(handler); }
    }, [productQty]);

    useEffect(() => {
        handlerHide = setTimeout(() => {
            hideMessage();
        }, 3000);

        return () => { clearTimeout(handlerHide) };
    }, []);

    return (
        <div
            className={styles.message}
            onMouseEnter={() => clearTimeout(handlerHide)}
        >
            <div className={styles.title}>
                {translate('Added to basket')}
                <button
                    className={styles.close}
                    onClick={hideMessage}
                />
            </div>
            {
                cartItems.map(({
                    id,
                    product: {
                        sku,
                        producttypeinenglish,
                        image: { url, label },
                        additional_attribute_data,
                        display_weight,
                        stock_status,
                        stock_data: {
                            max_sale_qty,
                        },
                        price_range: {
                            minimum_price: {
                                regular_price,
                                final_price,
                                discount: {
                                    percent_off,
                                } = {},
                            },
                        }
                    },
                    quantity,
                }) => (
                    <div
                        key={sku}
                        className={styles.item}
                    >
                        <img
                            src={`${url}?d=85x85`}
                            alt={label}
                            width="85"
                            height="85"
                        />
                        <div className={styles.details}>
                            <div className={styles.name}>
                                {producttypeinenglish}
                            </div>
                            <div>
                                <SmallQuantityButtons
                                    handleRemove={() => setProductQty({ ...productQty, [id]: productQty[id] === undefined ? quantity - 1 : productQty[id] - 1 })}
                                    handleAdd={() => setProductQty({ ...productQty, [id]: productQty[id] === undefined ? quantity + 1 : productQty[id] + 1 })}
                                    quantity={productQty[id] === undefined ? quantity : productQty[id]}
                                    isLoading={isLoadingCart || stock_status === STOCK_STATUSES.OUT_OF_STOCK}
                                    maxSaleQuantity={max_sale_qty}
                                />
                            </div>
                            <MaxSaleQtyMessage
                                isMax={(productQty[id] === undefined ? quantity : productQty[id]) === max_sale_qty}
                                message={translate('Maximum Qty Allowed in Shopping Cart %1', max_sale_qty)}
                            />
                        </div>
                        <div className={styles.info}>
                            <div className={styles.price}>
                                {`${formatPrice(!!percent_off ? final_price : regular_price)}`}
                            </div>
                            <div className={styles.qty}>
                                {`${getPackageSize(additional_attribute_data, display_weight)}, ${quantity}x${translate('QTY')}`}
                            </div>
                        </div>
                    </div>
                ))
            }
            <button
                className={styles.view}
                onClick={() => { navigate('/basket'); hideMessage(); }}
                disabled={isLoadingCart}
            >
                <IconBasket />
                {translate('View basket')}
            </button>
        </div>
    );
};

export default AddedProductsMessage;
